<app-currencies></app-currencies>